import React from 'react';

import { TemplateSideMenu } from 'components';
import { CtExamTemplate, CtPhishingTemplate, CtEduTemplate, CtEduQuizConf } from 'containers';

import styles from './TemplateLayout.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const TemplateLayout = ({ currentPath }) => {

  return (
    <div className={cx('templateLayout-wrapper')}>
      <div className={cx('list-area')}>
        <TemplateSideMenu />
      </div>
      <div className={cx('content-area')}>
        {currentPath === '/main/allTemplate/examtemplate' && <CtExamTemplate />}
        {currentPath === '/main/allTemplate/examtemplate/phishing' && <CtPhishingTemplate />}
        {currentPath === '/main/allTemplate/edutemplate' && <CtEduTemplate />}
        {currentPath === '/main/allTemplate/edutemplate/quiz' && <CtEduQuizConf />}
      </div>
    </div>
  );
};

export default TemplateLayout;



// WEBPACK FOOTER //
// ./src/script/components/exam/TemplateLayout.js